
const app = {
  state: {
    sidebar: {
      levTitle: '菜单栏',
      twoLev: '', // 二级菜单
      thrLev: '' // 三级菜单
    }
  },
  mutations: {
    TOGGLE_SIDEBAR: (state, param) => {
      state.sidebar.twoLev = param
    },
    TOGGLE_LEVTITLE: (state, param) => {
      state.sidebar.levTitle = param
    },
    TOGGLE_NAVBAR: (state, param) => {
      state.sidebar.thrLev = param
    }
  },
  actions: {
    ToggleSideBar: ({ commit }, acpar) => {
      commit('TOGGLE_SIDEBAR', acpar)
    },
    ToggleLevTitle: ({ commit }, acpar) => {
      commit('TOGGLE_LEVTITLE', acpar)
    },
    ToggleNavBar: ({ commit }, acpar) => {
      commit('TOGGLE_NAVBAR', acpar)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js